export default __webpack_public_path__ + "static/media/accelerated.2e450851.png";